import { FC, useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import SendMail from './SendMail';

/**
 * Shown on /forgotPassword when the link is wrong, expired, already used or
 * replaced by a newer one. The backend does not say which, on purpose.
 */
export const ResetLinkInvalid: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [sendMailOpen, setSendMailOpen] = useState(false);

  return (
    <Stack rowGap={3} sx={{ p: 3 }} data-testid="reset-link-invalid">
      <Typography align="center" fontSize={20} fontWeight={500}>
        {t('resetLink.invalid.title')}
      </Typography>
      <Typography align="center">{t('resetLink.invalid.body')}</Typography>
      <Stack rowGap={1}>
        <Button size="large" fullWidth variant="contained" onClick={() => setSendMailOpen(true)}>
          {t('resetLink.invalid.requestNew')}
        </Button>
        <Button size="large" fullWidth variant="outlined" onClick={() => navigate('/login')}>
          {t('sendMail.back')}
        </Button>
      </Stack>
      <SendMail open={sendMailOpen} onClose={() => setSendMailOpen(false)} />
    </Stack>
  );
};
